// https://i.ytimg.com/vi/JtUEEwVKj4c/(default|mqdefault|hqdefault|...).jpg
export const YOUTUBE_THUMBNAIL_PATTERN = /^(?:https?:)?\/\/i\.ytimg\.com\/vi\/([^/]+)\/([^.]+)\.jpg$/;
// https://yt3.ggpht.com/8Sz8FPziAwoISr4aTZ6OlE6dvHNKmc70Yrkk1WJO_9zuZ1ibjvgS_KbIjND79a4HKpG1Z3gD=s800-c-k-c0x00ffffff-no-rj
export const GOOGLE_PHOTO_PATTERN = /^((?:https?:)?\/\/yt3\.ggpht\.com\/.*=s)(\d+)(.*)(-rj)$/;
export function resizeGooglePhotoThumbnail(url, width, height) {
    const matches = url.match(GOOGLE_PHOTO_PATTERN);
    if (!matches) {
        return url;
    }
    // experimental, not externally documented googlepghotos api
    const thumbnailSizes = [88, 240, 800];
    const newSize = thumbnailSizes.find((thumbnailSize) => thumbnailSize >= width && (!height || thumbnailSize >= height));
    return [matches[1], newSize ?? matches[2], matches[3], '-rw'].join(''); // rj to rw for webp
}
// NOTE: `standard` and `maxres` sizes are skipped, because they may or may not exist for youtube video
const YOUTUBE_THUMBNAIL_SIZES = [
    {
        // Normal Quality Thumbnail
        name: 'mqdefault',
        width: 120,
        height: 90,
    },
    {
        // Medium Quality Thumbnail
        name: 'mqdefault',
        width: 320,
        height: 180,
    },
    {
        // High Quality Thumbnail
        name: 'mqdefault',
        width: 480,
        height: 360,
    },
];
// function webPify(ytUrl: string): string {
//   return ytUrl.replace('.jpg', '.webp').replace('/vi/', '/vi_webp/');
// }
/**
 * Get Youtube thumbnail image url with size that fits required `width` and `height`
 * @param {string} url
 * @param {number} width
 * @param {number} [height]
 * @returns {string}
 */
export function resizeYoutubeThumbnail(url, width, height) {
    const thumbnailMatch = url.match(YOUTUBE_THUMBNAIL_PATTERN);
    if (!thumbnailMatch) {
        return url;
    }
    const currentThumbnailSizeName = thumbnailMatch[2];
    const resizedThumbnailSize = YOUTUBE_THUMBNAIL_SIZES.find((thumbnailSize) => thumbnailSize.width >= width &&
        (!height || thumbnailSize.height >= height));
    if (resizedThumbnailSize &&
        resizedThumbnailSize.name !== currentThumbnailSizeName) {
        return url.replace(`${currentThumbnailSizeName}.jpg`, `${resizedThumbnailSize.name}.jpg`);
    }
    return url;
}
//# sourceMappingURL=resize-youtube-thumbnail.js.map